async function tryEachFunction(arrayOfFunctions = [], ...args) {
  let result
  let lastError
  let gotResult = false

  if (!Array.isArray(arrayOfFunctions) || !arrayOfFunctions.length) {
    throw new Error('Invalid input array')
  }

  let i = 0
  while (gotResult === false && i < arrayOfFunctions.length) {
    const func = arrayOfFunctions[i]
    if (typeof func === 'function') {
      try {
        result = await func.call(this, ...args)
        gotResult = true
      } catch (error) {
        lastError = error
      }
    }
    i++
  }

  if (!gotResult && lastError) {
    throw lastError
  }

  return result
}

exports.tryEachFunction = tryEachFunction

async function tryEachWithFunction(arrayOfEach = [], callbackFunction, ...args) {
  let result
  let lastError
  let gotResult = false

  if (!Array.isArray(arrayOfEach) || !arrayOfEach.length || typeof callbackFunction !== 'function') {
    throw new Error('Invalid input array')
  }

  let i = 0
  while (gotResult === false && i < arrayOfEach.length) {
    try {
      result = await callbackFunction.call(this, arrayOfEach[i], ...args)
      gotResult = true
    } catch (error) {
      lastError = error
    }
    i++
  }

  if (!gotResult && lastError) {
    throw lastError
  }

  return result
}

exports.tryEachWithFunction = tryEachWithFunction
